<div *ngIf="agents !== null && agents.length > 0" class="page-container">
  <div class="page-title">Agents</div>
  <button class="site-button blue" (click)="showAddAgentDialog = true;">Add Agent</button>
  <div class="data-table agents-table">
      <div class="header">ID</div>
      <div class="header">Name</div>
      <div class="header">Campaigns</div>
      <div class="header">Email</div>
      <div class="header">Phone</div>
      <div class="header">Sign Date</div>
      <ng-container *ngFor="let agent of agents">
        <div><a [routerLink]="['/admin/agents', agent.id]">{{agent.id.substring(0,8)}}</a></div>
        <div>{{agent.name}}</div>
        <div style="text-align: center;">{{agent.campaignCount}}</div>
        <div>{{agent.email}}</div>
        <div>{{agent.phoneNumber}}</div>
        <div>{{agent.birthDate | date: "MM/dd/yyyy"}}</div>
      </ng-container>
  </div>
</div>

<div *ngIf="showLoading" class="page-container">
  <div>Loading...</div>
</div>

<div *ngIf="showUnexpectedError" class="page-container">
  <div>An unexpected error occured while fetching data. Please try again later.</div>
</div>

<app-dialog [(visible)]="showAddAgentDialog">
  <div class="dialog-title">Add Agent</div>
  <div class="add-resource-form">
    <div class="input-label">Full Name</div>
    <div><input class="text-input" [(ngModel)]="newAgent.name" id="name" title="name" type="text" /></div>
    <div class="input-label">Email</div>
    <div><input class="text-input" [(ngModel)]="newAgent.email" id="email" title="email" type="text" /></div>
    <div class="input-label">Phone Number</div>
    <div><input class="text-input" [(ngModel)]="newAgent.phoneNumber" id="phoneNumber" title="phoneNumber" type="text" /></div>
    <div class="input-label">Sign Date</div>
    <div><input class="date-input" [(ngModel)]="newAgent.birthDate" id="birthDate" title="birthDate" type="date" /></div>
  </div>
  <div class="button-container">
    <button class="site-button blue" (click)="AddAgent()">Add Agent</button>
  </div>
</app-dialog>

